import router from 'next/router';
import { Space as SpaceComponent } from '@goatapp/web-content-components';
import { useEffect, useRef, useState } from 'react';

import { FeatureFlags } from 'featureFlags/constants';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { useIsElementInViewport } from 'shared/hooks/useIsElementInViewport';
import { useWindowSize } from 'shared/hooks/useWindowSize';

export const Space = ({ section, maxWidth }) => {
  const { articles } = section || {};
  const { isMobile } = useWindowSize();
  const moduleRef = useRef();
  const initialInViewport = useIsElementInViewport(moduleRef);
  const newPerformanceSpaceFlag = useFeatureFlag(FeatureFlags.TEMP_WEB_NEW_PERFORMANCE_SPACE);
  const [isModuleInViewport, setIsModuleInViewport] = useState(initialInViewport);

  const getCurrentSpace = () => {
    if (articles?.length === 1) {
      return articles?.[0]?.sections?.[0];
    }
    return isMobile ? articles?.[1]?.sections?.[0] : articles?.[0]?.sections?.[0];
  };

  const redirectToArticleAssetUrl = (url: string) => {
    if (!url) {
      return;
    }
    void router.push(url);
  };

  useEffect(() => {
    if (!isModuleInViewport) {
      setIsModuleInViewport(initialInViewport);
    }
  }, [initialInViewport, isModuleInViewport]);

  const currentSpace = getCurrentSpace();

  return (
    <div ref={moduleRef}>
      {isModuleInViewport && (
        <SpaceComponent
          space={currentSpace}
          maxWidth={maxWidth}
          onItemLinkClick={redirectToArticleAssetUrl}
          usePerformanceSpace={newPerformanceSpaceFlag}
        />
      )}
    </div>
  );
};
